export default "__VITE_ASSET__Cl1K2Awx__"